// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// তোমার পাঠানো স্ক্রিনশট থেকে প্রাপ্ত আসল কনফিগারেশন
const firebaseConfig = {
  apiKey: "AIzaSyCQKYbRhudvAAtT8LaJYbnjfZXu1g_bJSk", 
  authDomain: "ap-food-01.firebaseapp.com",
  projectId: "ap-food-01",
  storageBucket: "ap-food-01.firebasestorage.app",
  messagingSenderId: "89530998417",
  appId: "1:89530998417:web:04d310b3c262e0b5b2a930",
  measurementId: "G-16Y78T8DQZ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ প্রোফাইল পিকচারের জন্য এটি জরুরি

export default app;